import React from 'react';
import Icon from '../../ui/Icon';
import { T } from '../../constants/mockData';

export default function StatsWidget({ title, value, type = 'normal', onClick, hint }) {
  const isAlert = type === 'alert';
  const clickable = typeof onClick === 'function';

  return (
    <div
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={clickable ? onClick : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}
      title={clickable ? (hint || 'View matching tickets') : undefined}
      style={{
        padding: "16px 20px",
        borderRadius: 12,
        background: isAlert ? '#fce8eb' : '#ffffff',
        border: `1px solid ${isAlert ? '#fbd5d9' : T.border}`,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        minWidth: 140,
        flex: 1,
        cursor: clickable ? 'pointer' : 'default',
        transition: clickable ? 'box-shadow 0.15s, transform 0.15s' : undefined,
        boxShadow: clickable ? '0 1px 3px rgba(0,0,0,0.06)' : undefined,
      }}
      onMouseEnter={clickable ? (e) => { e.currentTarget.style.boxShadow = '0 4px 14px rgba(59,91,219,0.15)'; e.currentTarget.style.transform = 'translateY(-1px)'; } : undefined}
      onMouseLeave={clickable ? (e) => { e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'none'; } : undefined}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: '#2D3748', lineHeight: 1.4, maxWidth: '80%' }}>
          {title}
        </div>
        {isAlert && (
          <Icon name="warning" size={16} color="#dc2626" />
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 8 }}>
        <div style={{ fontSize: 28, fontWeight: 700, color: isAlert ? '#dc2626' : '#2563eb' }}>
          {value}
        </div>
        {clickable && (
          <span style={{ fontSize: 11, fontWeight: 600, color: '#3B5BDB', flexShrink: 0 }}>View →</span>
        )}
      </div>
    </div>
  );
}
